import { render, staticRenderFns } from "./comp_BookEditorInput-Image-Cropper.vue?vue&type=template&id=4cbbc8e6&"
import script from "./comp_BookEditorInput-Image-Cropper.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorInput-Image-Cropper.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorInput-Image-Cropper.vue?vue&type=style&index=0&id=4cbbc8e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
